import { render, staticRenderFns } from "./rollBox.vue?vue&type=template&id=a121841e&scoped=true&"
import script from "./rollBox.vue?vue&type=script&lang=js&"
export * from "./rollBox.vue?vue&type=script&lang=js&"
import style0 from "./rollBox.vue?vue&type=style&index=0&id=a121841e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a121841e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a121841e')) {
      api.createRecord('a121841e', component.options)
    } else {
      api.reload('a121841e', component.options)
    }
    module.hot.accept("./rollBox.vue?vue&type=template&id=a121841e&scoped=true&", function () {
      api.rerender('a121841e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/home/components/rollBox.vue"
export default component.exports